module.exports = __webpack_public_path__ + "img/Mask_group@2x.5cddd7f5.png";